export function isNotSoldOut(state) {
    const product = state.product;

    // if product is removeForLegalReasons, forceSoldOut, or soldOut
    // regardless of displaySoldOut it isn't valid
    if (product.productUnavailable || product.isSoldOut) {
        return false;
    }

    return true;
}

export default {
    isNotSoldOut: isNotSoldOut
};
